import { ReactNode } from "@tanstack/react-router";
import { HTMLAttributes, TdHTMLAttributes, ThHTMLAttributes } from "react";
import { body, header, table, tdStyle, thStyle, trStyle } from "./index.css";

type TableProps = {
	children: ReactNode | ReactNode[];
} & HTMLAttributes<HTMLTableElement>;

function Table({ children, ...rest }: TableProps) {
	return (
		<table className={table} {...rest}>
			{children}
		</table>
	);
}

type TableHeaderProps = {
	children: ReactNode | ReactNode[];
} & HTMLAttributes<HTMLTableSectionElement>;

function Header({ children, ...rest }: TableHeaderProps) {
	return (
		<thead className={header} {...rest}>
			{children}
		</thead>
	);
}

type TableTRProps = {
	children: ReactNode | ReactNode[];
} & HTMLAttributes<HTMLTableRowElement>;

function TR({ children, ...rest }: TableTRProps) {
	return (
		<tr className={trStyle} {...rest}>
			{children}
		</tr>
	);
}

type TableTHProps = {
	children: ReactNode | ReactNode[];
} & ThHTMLAttributes<HTMLTableCellElement>;

function TH({ children, ...rest }: TableTHProps) {
	return (
		<th className={thStyle} {...rest}>
			{children}
		</th>
	);
}

type TableBodyProps = {
	children: ReactNode | ReactNode[];
} & HTMLAttributes<HTMLTableSectionElement>;

function Body({ children, ...rest }: TableBodyProps) {
	return (
		<tbody className={body} {...rest}>
			{children}
		</tbody>
	);
}

type TableTDProps = {
	children: ReactNode | ReactNode[];
} & TdHTMLAttributes<HTMLTableCellElement>;

function TD({ children, ...rest }: TableTDProps) {
	return (
		<td className={tdStyle} {...rest}>
			{children}
		</td>
	);
}

Table.Header = Header;
Table.TR = TR;
Table.TH = TH;
Table.Body = Body;
Table.TD = TD;

export default Table;